import { isNil, map, pick, trim } from 'lodash'

export const transformMenuCurationTaskFormValuesToUpdateArgs = formValues =>
  pick(
    {
      ...formValues,
      ...(!isNil(formValues.dietLabelLegends) && {
        dietLabelLegends: map(
          formValues.dietLabelLegends,
          ({ id: dietLabelLegendId, created, label, ...rest }) => ({
            label: trim(label),
            ...pick(
              created ? { ...rest } : { id: dietLabelLegendId, ...rest },
              [
                'id',
                'dietId',
                'label',
                'isSuggestedByAi',
                'conflictResolutionType',
              ],
            ),
          }),
        ),
      }),
      ...(!isNil(formValues.allergenLabelLegends) && {
        allergenLabelLegends: map(
          formValues.allergenLabelLegends,
          ({ id: allergenLabelLegendId, created, label, ...rest }) => ({
            label: trim(label),
            ...pick(
              created ? { ...rest } : { id: allergenLabelLegendId, ...rest },
              [
                'id',
                'allergenId',
                'label',
                'isSuggestedByAi',
                'conflictResolutionType',
              ],
            ),
          }),
        ),
      }),
    },
    [
      'tags',
      'problemReason',
      'problemComment',
      'curationDetailLevel',
      'languageIds',
      'dietLabelLegends',
      'allergenLabelLegends',
      'cuisineTypeId',
    ],
  )
